import { render, staticRenderFns } from "./IconCircledArrow.vue?vue&type=template&id=72aa7a08"
import script from "./IconCircledArrow.vue?vue&type=script&lang=js"
export * from "./IconCircledArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports